import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DowntimeMessageService } from './downtime-message.service';

@Component({
  selector: 'app-downtime-message',
  templateUrl: './downtime-message.component.html',
  styleUrls: ['./downtime-message.component.scss']
})
export class DowntimeMessageComponent implements OnInit {
  @Input() guid: string;
  @Output() hasCurrentDowntime = new EventEmitter<void>();

  private storageKey: string;

  messages = '';
  count = 0;
  expanded = true;

  constructor(
    private service: DowntimeMessageService
  ) { }

  ngOnInit(): void {
    this.storageKey = `${this.guid}-expanded`;

    this.service.getDownTimeMessages(this.guid).subscribe(res => {
      for(const message of res) {
        this.messages += message.value?.section1;
      }

      this.count = res?.length;

      if(this.messages.includes('current-downtime')) {
        this.hasCurrentDowntime.emit();
      }
    });

    const isExpanded = sessionStorage.getItem(this.storageKey);
    this.expanded = isExpanded === null ? true : !!+isExpanded;
  }

  toggle(): void {
    this.expanded = !this.expanded;
    sessionStorage.setItem(this.storageKey, (+this.expanded).toString());
  }
}
